import { useEffect } from "react";

const toggleFeedbackTab = (shouldDisplay: boolean) => {
  const feedbackTab = document.getElementById("QSIFeedbackButton-btn");
  if (feedbackTab) {
    feedbackTab.style.display = shouldDisplay ? "block" : "none";
  }
};

export function useHideFeedbackTab() {
  useEffect(() => {
    toggleFeedbackTab(false);
    return () => {
      toggleFeedbackTab(true);
    };
  }, []);
}
